export default "__VITE_ASSET__7y_KvBuh__"